import React, { useEffect, useState } from 'react';
import { Grid, TextField } from '@mui/material';
import Divider from '@mui/material/Divider';
import dayjs, { Dayjs } from 'dayjs';
import { textFieldHandlerBuilder } from '../../utils/inputHandlers';
import { isStringEmpty } from '../../utils/formValidation';
import StartEndDatePicker from './StartEndDatePicker';
import NotificationBar from '../common/NotificationBar';
import ProfileSectionController from './ProfileSectionController';
import APICaller, { MethodType } from '../common/APICaller';

export interface WorkExperience {
  id: number | null;
  company: string;
  title: string;
  location: string;
  startDate: string | null;
  endDate: string | null;
}
interface WorkExperienceProp {
  data: WorkExperience;
  deleteRecord: (idx: number) => void;
  idx: number;
  viewMode?: boolean;
}

const WorkExperienceRecord: React.FC<WorkExperienceProp> = ({
  data,
  deleteRecord,
  idx,
  viewMode = false,
}) => {
  const [title, setTitle] = useState<string>(data.title);
  const [company, setCompany] = useState<string>(data.company);
  const [location, setLocation] = useState<string>(data.location);
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const [workExpId, setWorkExpId] = useState<number | null>(data.id);

  const [startDateValid, setStartDateValid] = useState<boolean>(true);
  const [endDateValid, setEndDateValid] = useState<boolean>(true);
  const [isTitleEmpty, setIsTitleEmpty] = useState<boolean>(false);
  const [isCompanyEmpty, setISCompanyEmpty] = useState<boolean>(false);
  const [isLocationEmpty, setIsLocationEmpty] = useState<boolean>(false);

  const [showNotification, setShowNotification] = useState(false);
  useEffect(() => {
    setTitle(data.title);
    setCompany(data.company);
    setLocation(data.location);
    setStartDate(data.startDate ? dayjs(data.startDate) : null);
    setEndDate(data.startDate ? dayjs(data.endDate) : null);
    setWorkExpId(data.id);
  }, [data]);

  const saveButtonHandler = () => {
    const titleFieldEmpty = isStringEmpty(title);
    const companyFieldEmpty = isStringEmpty(company);
    const locationFieldEmpty = isStringEmpty(location);
    setIsTitleEmpty(titleFieldEmpty);
    setISCompanyEmpty(companyFieldEmpty);
    setIsLocationEmpty(locationFieldEmpty);
    setStartDateValid(startDate != null);
    setEndDateValid(endDate != null);
    console.log(startDate, endDate);
    if (
      !titleFieldEmpty &&
      !companyFieldEmpty &&
      !locationFieldEmpty &&
      !(startDate == null) &&
      !(endDate == null)
    ) {
      const route = workExpId
        ? `/profile/workexp/${workExpId}/update`
        : `/profile/workexp/create`;
      const method = workExpId ? MethodType.PUT : MethodType.POST;
      const data = {
        workExp: {
          location,
          title,
          company,
          startDate: startDate?.toString(),
          endDate: endDate?.toString(),
        },
      };
      APICaller(route, method, data).then(res => {
        // console.log(res)
        if (res.errorMessage) {
          alert(res.errorMessage);
          return;
        }
        if (res.workExpId) {
          setWorkExpId(res.workExpId);
          setShowNotification(true);
        }
      });
    }
  };

  const deleteButtonHandler = () => {
    if (workExpId) {
      APICaller(`/profile/workexp/${workExpId}/delete`, MethodType.DELETE).then(
        res => {
          if (res.errorMessage) {
            alert(res.errorMessage);
            return;
          }
          deleteRecord(idx);
        },
      );
    } else {
      deleteRecord(idx);
    }
  };
  return (
    <>
      <Grid
        container
        direction="row"
        alignItems="center"
        sx={{ marginBottom: '10px' }}
      >
        <Divider
          sx={{
            marginTop: idx === 0 ? '6px' : '3vh',
            width: '100%',
            fontFamily: 'inherit',
            fontWeight: 'bold',
          }}
          textAlign="center"
        >
          {`Work Experience ${idx + 1}`}
        </Divider>
        <Grid item container spacing={2} xs={12} md={12}>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              error={isTitleEmpty}
              value={title}
              onChange={textFieldHandlerBuilder(setTitle)}
              required
              fullWidth
              name="title"
              label="Job Title"
              type="text"
              id="title"
              InputProps={{ sx: { borderRadius: '12px', padding: '4px 2px', backgroundColor: '#f8f9fb' } }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              error={isCompanyEmpty}
              value={company}
              onChange={textFieldHandlerBuilder(setCompany)}
              required
              fullWidth
              name="company"
              label="Company"
              type="text"
              id="company"
              InputProps={{ sx: { borderRadius: '12px', padding: '4px 2px', backgroundColor: '#f8f9fb' } }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <TextField
              error={isLocationEmpty}
              value={location}
              onChange={textFieldHandlerBuilder(setLocation)}
              required
              fullWidth
              name="location"
              label="Location"
              type="text"
              id="location"
              InputProps={{ sx: { borderRadius: '12px', padding: '4px 2px', backgroundColor: '#f8f9fb' } }}
            />
          </Grid>
          <StartEndDatePicker
            startDateValue={startDate}
            startDateValid={startDateValid}
            endDateValue={endDate}
            endDateValid={endDateValid}
            onStartDateChange={setStartDate}
            onEndDateChange={setEndDate}
            dateRequired={true}
          />
        </Grid>
        {viewMode ? null : (
          <ProfileSectionController
            saveButtonHandler={saveButtonHandler}
            deleteButtonHandler={deleteButtonHandler}
          />
        )}
      </Grid>
      {viewMode ? null : (
        <NotificationBar
          open={showNotification}
          setOpen={setShowNotification}
          title="Successs!"
          message="Your change has been saved!"
        />
      )}
    </>
  );
};

export default WorkExperienceRecord;
